import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { company } from "../mock";
import PageHero from "../components/PageHero";
import BookingForm from "../components/BookingForm";
import Reveal from "../components/Reveal";

const infoCards = [
  { icon: Phone, label: "Call us", value: company.phone, href: company.phoneHref },
  { icon: Mail, label: "Email us", value: company.email, href: `mailto:${company.email}` },
  { icon: MapPin, label: "Service area", value: company.serviceArea },
  { icon: Clock, label: "Response time", value: "Within one business day" }
];

export default function Contact() {
  return (
    <main>
      <PageHero
        eyebrow="Contact Us"
        title="Book a free site visit"
        subtitle="Tell us about your space and we'll confirm eligibility and arrange a visit — usually within one business day."
      />

      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-5 gap-10">
          {/* Info */}
          <div className="lg:col-span-2 space-y-4">
            {infoCards.map((c) => {
              const Inner = (
                <div className="flex items-start gap-4 rounded-2xl border border-gold/20 bg-gold-soft/40 p-6 hover:border-gold transition-colors">
                  <span className="grid place-items-center h-12 w-12 rounded-xl bg-ink text-gold shrink-0">
                    <c.icon size={20} />
                  </span>
                  <div>
                    <p className="text-xs uppercase tracking-widest text-muted-foreground">{c.label}</p>
                    <p className="mt-1 font-semibold text-ink">{c.value}</p>
                  </div>
                </div>
              );
              return c.href ? (
                <a key={c.label} href={c.href} className="block">{Inner}</a>
              ) : (
                <div key={c.label}>{Inner}</div>
              );
            })}
          </div>

          {/* Form */}
          <div className="lg:col-span-3">
            <Reveal>
              <div className="rounded-2xl border border-gold/25 bg-white p-6 sm:p-8 shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
                <h2 className="font-display text-2xl text-ink">Send your request</h2>
                <p className="mt-1 text-sm text-muted-foreground">We'll confirm eligibility and contact you to arrange the best time.</p>
                <div className="mt-6">
                  <BookingForm source="contact" />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
